






































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import Utils from "@/store/utils.ts";
import { getCookie, setCookie } from "@/JS/cookie"; //使用getCookie方法
import Bus from "@/JS/Bus";
@Component({
  components: {}
})
export default class LeftMenu extends Vue {
  @Provide() activeTencent: any = "";
  @Provide() accountsList: any = [];

  //初始化
  created() {
    let _this = this;
    _this.accountsList = JSON.parse(Utils.decrypt(localStorage.getItem("tencentsList") as any, ""));
    _this.activeTencent = JSON.parse(Utils.decrypt(localStorage.getItem("activeTencent") as any, ""));
    window.addEventListener("beforeunload", () => {});
  }
  //公众号切换
  switchAccountFn(tencent: any) {
    let _this = this;
    let expireDays = 1000 * 60 * 60;

    _this.activeTencent = tencent;
    localStorage.setItem('activeTencent', Utils.encrypt(JSON.stringify(tencent), ""));

    setCookie("Aid", tencent.Aid, expireDays);
    setCookie("typeCode", tencent.TypeCode, expireDays);
    setCookie("TenantID", tencent.TenantID, expireDays);

    this.$store.commit("SetAId", tencent.Aid);
    this.$store.commit("SetTypeCode", tencent.TypeCode);
    localStorage.removeItem('target'); // 移除新窗口跳转生成的，避免在切换公众号时，没有当前菜单不能跳转公众号列表页

    // Bus.$emit("switchAccountFn", tencent);
  }
}
